import React from 'react';
// import './Modal.css'; // Para estilos opcionales

export const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null; // Si no está abierto, no mostrar nada.

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>X</button>
        {children} {/* Aquí va el contenido de la modal */}
      </div>
    </div>
  );
};

export default Modal;